import { createNamespacedWetagHooksForOrg } from '@frontend/wetags';
import { GLS_WETAG_CONFIG } from './config';
import type { GlsTags } from './tags';

export const GlsOrg = createNamespacedWetagHooksForOrg<GlsTags>(GLS_WETAG_CONFIG.NAMESPACE);
